(function ($) {
    if ($('.apartments-search').length) {
        const rangeSliders = [];
        let url = window.location.href;
        var url1 = new URL(window.location);
        var urlParams = (new URL(document.location)).searchParams;

        function numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        }

        $(".range-slider").each(function (index, el) {
            let queryString2 = window.location.search;
            let urlParams2 = new URLSearchParams(queryString2);
            if(urlParams2.get('area-range-min') || urlParams2.get('area-range-max') || urlParams2.get('price-from') || urlParams2.get('price-to')  ) {
                if(index == 0) {

                    $(el).find('.js-range-slider').ionRangeSlider({
                        from: urlParams2.get('area-range-min'),
                        to: urlParams2.get('area-range-max'),
                        onStart: function (data) {
                            $(el).find('.range-value-from').text(numberWithCommas(data.from) + $(el).data('symbol'));
                            $(el).find('.range-value-to').text(numberWithCommas(data.to) + $(el).data('symbol'));
                        },
                        onChange: function (data) {
                            $(el).find('.range-value-from').text(data.from_pretty + $(el).data('symbol'));
                            $(el).find('.range-value-to').text(data.to_pretty + $(el).data('symbol'));
                            updateUrlParamsBatch([
                                {param: 'area-range-min', value: data.from_pretty},
                                {param: 'area-range-max', value: data.to_pretty}
                            ]);
                        },
                        onUpdate: function (data) {
                            $(el).find('.range-value-from').text(data.from_pretty + $(el).data('symbol'));
                            $(el).find('.range-value-to').text(data.to_pretty + $(el).data('symbol'));
                        }
                    });
                } else {
                    $(el).find('.js-range-slider').ionRangeSlider({
                        from: urlParams2.get('price-from'),
                        to: urlParams2.get('price-to'),
                        onStart: function (data) {
                            $(el).find('.range-value-from').text(numberWithCommas(data.from) + $(el).data('symbol'));
                            $(el).find('.range-value-to').text(numberWithCommas(data.to) + $(el).data('symbol'));
                        },
                        onChange: function (data) {
                            $(el).find('.range-value-from').text(data.from_pretty + $(el).data('symbol'));
                            $(el).find('.range-value-to').text(data.to_pretty + $(el).data('symbol'));
                            updateUrlParamsBatch([
                                {param: 'price-from', value: data.from},
                                {param: 'price-to', value: data.to}
                            ]);
                        },
                        onUpdate: function (data) {
                            $(el).find('.range-value-from').text(data.from_pretty + $(el).data('symbol'));
                            $(el).find('.range-value-to').text(data.to_pretty + $(el).data('symbol'));
                        }
                    });
                }
            } else {
                // if (index == 0) {
                    $(el).find('.js-range-slider').ionRangeSlider({
                        onStart: function (data) {
                            $(el).find('.range-value-from').text(numberWithCommas(data.from) + $(el).data('symbol'));
                            $(el).find('.range-value-to').text(numberWithCommas(data.to) + $(el).data('symbol'));
                        },
                        onChange: function (data) {
                            $(el).find('.range-value-from').text(data.from_pretty + $(el).data('symbol'));
                            $(el).find('.range-value-to').text(data.to_pretty + $(el).data('symbol'));
                            if (index == 0) {
                                updateUrlParamsBatch([
                                    {param: 'area-range-min', value: data.from},
                                    {param: 'area-range-max', value: data.to}
                                ]);
                            } else {
                                updateUrlParamsBatch([
                                    {param: 'price-from', value: data.from},
                                    {param: 'price-to', value: data.to}
                                ]);
                            }
                        },
                        onUpdate: function (data) {
                            $(el).find('.range-value-from').text(data.from_pretty + $(el).data('symbol'));
                            $(el).find('.range-value-to').text(data.to_pretty + $(el).data('symbol'));
                        }
                    });
                // }

            }
            let rangeSlider = $(el).find('.js-range-slider').data("ionRangeSlider");
            rangeSliders.push(rangeSlider);
        })
        function updatePriceRangeSlider(range_instance, min_price, max_price) {
            updateUrlParamsBatch([
                {param: 'price-from', value: min_price},
                {param: 'price-to', value: max_price}
            ]);
            range_instance.update({
                from: min_price,
                to: max_price,
                min: min_price,
                max:max_price,
                onUpdate: function (data){
                    $('#price-range-slider').siblings('.range-values').children('.range-value-from').text(min_price + ' €');
                    $('#price-range-slider').siblings('.range-values').children('.range-value-to').text(max_price + ' €');
                    updateUrlParamsBatch([
                        {param: 'price-from', value: min_price},
                        {param: 'price-to', value: max_price}
                    ]);
                },
            });
        }

        $('.apartments-block .toggle-list li').on('click', function () {
            if ($(this).hasClass('active')) return;

            const tab = $(this).data('tab');
            $(this).addClass('active').siblings().removeClass('active');

            $('.apartments-block .apartments-tab').removeClass('active').filter(`[data-tab="${tab}"]`).addClass('active');

            $(`.mobile-filter-triggers .list-type-toggle[data-list-type="${tab}"]`).addClass('active').siblings().removeClass('active');
        })

        $('.mobile-filter-triggers .list-type-toggle').on('click', function() {
            if ($(this).hasClass('active')) return;
            const type = $(this).data('list-type');
            $(this).addClass('active').siblings().removeClass('active');
            $(`.apartments-block .toggle-list li[data-tab="${type}"]`).addClass('active').siblings().removeClass('active');
            $('.apartments-block .apartments-tab').removeClass('active').filter(`[data-tab="${type}"]`).addClass('active');
        });

        $('.apartments-search .filter-with-params').on('click', function () {
            url = document.URL.split('?')[0];
            window.history.pushState('', '/', url);
        })

        if ( liven.table_image_hover ) {
            $('.apartments-block .apartments-table td a').on('mouseenter', function () {
                const image = $(this).closest('tr').data('image');
                if (image.length) {
                    $('.table-hover-image').addClass('active');
                    $('.table-hover-image img').attr('src', image);

                    $('.table-hover-image img').on('load', function () {
                        $(this).addClass('active');
                    })
                }
            });
        }

        $('.apartments-block .apartments-table td a').on('mouseleave', function () {
            $('.table-hover-image').removeClass('active');
            $('.table-hover-image img').removeClass('active');
        });

        $(window).on('load', function () {
            filterApartments();
            let spliteUrl = url.split( '?building-id=' )[1];
            if(spliteUrl) {
                $(`.buildings-selection input[value='${spliteUrl}']`)[0].click();
            }

            // Show clear filters button if active filters
            var activeFilters = $('form[name="apartment-filters"]').serializeArray();
            if ( activeFilters.length > 2 ) {
                $('.c-clear-filters-block').removeClass('is-hidden');
            }
        });

        // Filter and search

        const apartmentsList = $('.apartments-table tbody tr');
        const apartmentsWithImageList = $('.apartments-image-list>li');
        const mobileApartmentsList = $('.apartments-table-mobile .apartment');

        let minPriceRange;
        let maxPriceRange;

        const filterApartments = () => {
            $('.homes-page .apartments-table tbody tr').removeClass('filtered-tr')
            let apartmentPriceArray = [];
            const filters = $('form[name="apartment-filters"]').serializeArray();
            let onlyVacantHomes = $('input[name="only-vacant-homes-desktop"]')[0] ? $('input[name="only-vacant-homes-desktop"]')[0].checked : "";
            let minArea;
            let maxArea;
            let roomCount = [];
            let minPrice;
            let maxPrice;
            let apartmentStatus = [];
            let buildingStatus = [];
            let apartmentFeature = [];
            let buildingName = [];
            let buildingFeature = [];
            let apartmentFloor = [];
            let url_building_name = [];
            let apartmentFeaturesPerRoom = [];

            filters.forEach(function (el, index) {
                if (el.name === "building-name-desktop") {
                    if(url.includes('?building-id')){
                        buildingName.push(Number(url.split( '?building-id=' )[1]));
                        url_building_name.push(Number(url.split( '?building-id=' )[1]));
                    }
                    buildingName.push(Number(el.value));
                    url_building_name.push({
                        'building-name-desktop': Number(el.value)
                    });
                }
                if (el.name === "area-range") {
                    minArea = el.value.split(';')[0]
                    maxArea = el.value.split(';')[1]
                    url_building_name.push({
                        'area-range-min': Number(el.value.split(';')[0]),
                        'area-range-max': Number(el.value.split(';')[1]),
                    });
                }
                if (el.name === "room-count") {
                    roomCount.push(Number(el.value).toString());
                    url_building_name.push({
                        'room-count': el.value.toString()
                    });
                }
                if (el.name === "price-range") {
                    minPrice = el.value.split(';')[0]
                    maxPrice = el.value.split(';')[1]
                    url_building_name.push({
                        'price-range-min': Number(el.value.split(';')[0]),
                        'price-range-max': Number(el.value.split(';')[1])
                    });
                }
                if (el.name === "apartment-status") {
                    apartmentStatus.push(el.value);
                    url_building_name.push({
                        'apartment-status': (el.value)
                    });
                }
                if (el.name === "building-status") {
                    buildingStatus.push(el.value);
                    url_building_name.push({
                        'building-status': (el.value)
                    });
                }
                if (el.name === "apartment-feature") {
                    apartmentFeature.push(el.value);
                    url_building_name.push({
                        'apartment-feature': (el.value)
                    });
                }
                if (el.name === "apartment-layout-feature") {
                    buildingFeature.push(el.value);
                    apartmentFeaturesPerRoom.push(el.value);
                    if(url_building_name.hasOwnProperty("apartment-layout-feature")) {
                        url_building_name.push(el.value);
                    }else {
                        url_building_name.push({
                            'apartment-layout-feature': (el.value)
                        });
                    }

                }
                if (el.name === "apartment-floor") {
                    //apartmentFloor.push(Number(el.value));
                    apartmentFloor.push( el.value );
                    url_building_name.push({
                        //'apartment-floor': (Number(el.value))
                        'apartment-floor': el.value
                    });
                }
            })

            const filteredApartments = apartmentsList.filter(function (index) {

                let jsonString = $(this).data('apartment-layout-features');
                let apartmentLayoutsFeatures = '';
                let arrayApartmentLayoutFeatures = [];
                if(buildingFeature.length) {
                    $(jsonString).each(function () {
                        let singleLayoutArray = this;
                        if (buildingFeature.length === 1) {
                            apartmentLayoutsFeatures = buildingFeature.every(feature => (singleLayoutArray.toString().split(',').includes(feature)));
                            arrayApartmentLayoutFeatures.push(apartmentLayoutsFeatures);
                        } else if (buildingFeature.length > 1) {
                            apartmentLayoutsFeatures = buildingFeature.every(feature => (singleLayoutArray.toString().split(',').includes(feature)));
                            arrayApartmentLayoutFeatures.push(apartmentLayoutsFeatures);
                        }
                    });


                    if(buildingFeature.length === 1) {
                        if ($.inArray(true, arrayApartmentLayoutFeatures) != -1) {
                            apartmentLayoutsFeatures = true;
                        }
                    }else if(buildingFeature.length >1) {
                        if ($.inArray(true, arrayApartmentLayoutFeatures) != -1) {
                            apartmentLayoutsFeatures = true;
                        }
                    }
                }

                // Debug
                //
                let onlyLayoutHasFeature = false;
                if ( roomCount.length == 1 ) {
                    let roomLayouts = $(this).data('apartment-layout-features-per-room');

                    if (roomLayouts && roomLayouts[roomCount[0]]) {
                        let layoutOnlyFeatures = roomLayouts[roomCount[0]]

                        if ( layoutOnlyFeatures ) {
                            $.each( apartmentFeaturesPerRoom, function( index, value ) {
                                let hasFeatureInRoomLayout = layoutOnlyFeatures.includes( Number(value) );
                                if( hasFeatureInRoomLayout === true ) {
                                    onlyLayoutHasFeature = true;
                                }
                            });
                        }
                    }
                }
                /*
                if ( roomCount.length > 0 && apartmentFeaturesPerRoom.length > 0 ) {


                    console.log( $(this).data('apartment-layout-features-per-room') );
                    console.log( roomCount[0] );
                    console.log( layoutOnlyFeatures );
                    console.log( apartmentFeaturesPerRoom );

                    apartmentFeaturesPerRoom.each(function (element) {
                        console.log( element );
                        console.log( layoutOnlyFeatures.includes(apartmentFeaturesPerRoom) );
                        //layoutOnlyFeatures.includes(apartmentFeaturesPerRoom);

                    });
                }*/

                // Room count
                //
                let roomShow = true;
                if(String($(this).data('rooms')).length > 1) {
                    let statusRoom = roomCount.some( ai => String($(this).data('rooms')).split(',').includes(ai) );
                    if(statusRoom == true) {
                        roomShow = true;
                    }else {
                        roomShow = false;
                    }
                } else {
                    roomShow = roomCount.length ? roomCount.includes(String($(this).data('rooms'))) : true;
                }

                // Price
                //
                let price = Number($(this).data('price'));

                // Return
                //
                return (minArea ? (Number($(this).data('area-min')) >= Number(minArea) || Number($(this).data('area-max')) >= Number(minArea)) : true) &&
                    (maxArea ? (Number($(this).data('area-max')) <= Number(maxArea) || Number($(this).data('area-min')) <= Number(maxArea)) : true) &&
                    ((minPrice && price != 0 ) ? Number($(this).data('price')) >= Number(minPrice) : true) &&
                    ((maxPrice && price != 0) ? Number($(this).data('price')) <= Number(maxPrice) : true) &&
                    (roomCount.length ? roomShow : true) &&
                    ((buildingName.length !== 0) ? buildingName.includes($(this).data('building-name-desktop')) : true) &&
                    (apartmentStatus.length ? apartmentStatus.includes($(this).data('status')) : true) &&
                    (buildingStatus.length ? buildingStatus.includes($(this).data('building-status')) : true) &&
                    ((apartmentFeature.length !== 0) ? apartmentFeature.every(feature => String($(this).data('apartment-features')).split(',').includes(feature)) : true) &&
                    (onlyLayoutHasFeature ? onlyLayoutHasFeature : true) &&
                    //(apartmentFloor.length ? apartmentFloor.includes($(this).data('floor')) : true) &&
                    (apartmentFloor.length ? apartmentFloor.map(String).includes(String($(this).data('floor'))) : true) &&
                    (onlyVacantHomes ? !["sold", "booked"].includes($(this).data('status')) : true) &&
                    ((buildingFeature.length !== 0)  ? apartmentLayoutsFeatures : true);
            });


            // Calculate min/max price range for filtered apartments
            filteredApartments.each(function (index, el) {
                if($(this).data('price').length !==0) {
                    apartmentPriceArray.push(Number($(this).data('price')));
                }
            })

            minPriceRange = Math.min.apply(Math,apartmentPriceArray);
            maxPriceRange = Math.max.apply(Math,apartmentPriceArray);



            const filteredApartmentsWithImage = apartmentsWithImageList.filter(function () {
                let roomShow = true;
                const price = Number($(this).data('price')) || 0;

                if ($(this).data('rooms').length > 1) {
                    let statusRoom = roomCount.some(ai =>
                        String($(this).data('rooms')).split(',').includes(ai)
                    );
                    roomShow = statusRoom;
                } else {
                    roomShow = roomCount.length ? roomCount.includes(String($(this).data('rooms'))) : true;
                }

                let jsonString = $(this).data('apartment-layout-features');
                if (typeof jsonString === "string") {
                    try {
                        jsonString = JSON.parse(jsonString);
                    } catch (e) {
                        jsonString = [];
                    }
                }

                let apartmentLayoutsFeatures = '';
                let arrayApartmentLayoutFeatures = [];

                if (buildingFeature.length) {
                    $(jsonString).each(function () {
                        let singleLayoutArray = this;
                        if (buildingFeature.length === 1) {
                            apartmentLayoutsFeatures = buildingFeature.every(feature =>
                                singleLayoutArray.toString().split(',').includes(feature)
                            );
                            arrayApartmentLayoutFeatures.push(apartmentLayoutsFeatures);
                        } else if (buildingFeature.length > 1) {
                            apartmentLayoutsFeatures = buildingFeature.every(feature =>
                                singleLayoutArray.toString().split(',').includes(feature)
                            );
                            arrayApartmentLayoutFeatures.push(apartmentLayoutsFeatures);
                        }
                    });

                    if (buildingFeature.length === 1) {
                        if ($.inArray(true, arrayApartmentLayoutFeatures) !== -1) {
                            apartmentLayoutsFeatures = true;
                        }
                    } else if (buildingFeature.length > 1) {
                        if ($.inArray(true, arrayApartmentLayoutFeatures) !== -1) {
                            apartmentLayoutsFeatures = true;
                        }
                    }
                }

                let onlyLayoutHasFeature = false;
                if (roomCount.length === 1) {
                    let roomLayouts = $(this).data('apartment-layout-features-per-room');
                    if (roomLayouts && roomLayouts[roomCount[0]]) {
                        let layoutOnlyFeatures = roomLayouts[roomCount[0]];
                        if (layoutOnlyFeatures) {
                            $.each(apartmentFeaturesPerRoom, function (index, value) {
                                let hasFeatureInRoomLayout = layoutOnlyFeatures.includes(Number(value));
                                if (hasFeatureInRoomLayout === true) {
                                    onlyLayoutHasFeature = true;
                                }
                            });
                        }
                    }
                }

                return (
                    (minArea ? (Number($(this).data('area-min')) >= Number(minArea) || Number($(this).data('area-max')) >= Number(minArea)) : true) &&
                    (maxArea ? (Number($(this).data('area-max')) <= Number(maxArea) || Number($(this).data('area-min')) <= Number(maxArea)) : true) &&
                    ((minPrice && price !== 0) ? price >= Number(minPrice) : true) &&
                    ((maxPrice && price !== 0) ? price <= Number(maxPrice) : true) &&
                    (roomCount.length ? roomShow : true) &&
                    ((buildingName.length !== 0) ? buildingName.includes($(this).data('building-name-desktop')) : true) &&
                    (apartmentStatus.length ? apartmentStatus.includes($(this).data('status')) : true) &&
                    (buildingStatus.length ? buildingStatus.includes($(this).data('building-status')) : true) &&
                    ((apartmentFeature.length !== 0) ? apartmentFeature.every(feature =>
                        String($(this).data('apartment-features')).split(',').includes(feature)
                    ) : true) &&
                    (onlyLayoutHasFeature ? onlyLayoutHasFeature : true) && // FIX 3 added
                    (apartmentFloor.length ? apartmentFloor.map(String).includes(String($(this).data('floor'))) : true) && // FIX 4
                    (onlyVacantHomes ? !["sold", "booked"].includes($(this).data('status')) : true) &&
                    ((buildingFeature.length !== 0) ? apartmentLayoutsFeatures : true)
                );
            });

            if ($('.page-template-template-homes .apartments-search').length == 0) {
                $('.table-empty-err').removeClass('active');
                $('.project-block').removeClass('active');

                if (filteredApartmentsWithImage.length === 0) {
                    $('.table-empty-err').addClass('active');
                    $('.project-block').addClass('active');
                }
            }
            const filteredMobileApartments = mobileApartmentsList.filter(function() {
                let roomShow = true;
                if($(this).data('rooms').length > 1) {
                    let statusRoom = roomCount.some( ai => String($(this).data('rooms')).split(',').includes(ai) );
                    if(statusRoom == true) {
                        roomShow = true;
                    }else {
                        roomShow = false;
                    }
                }else {
                    roomShow = roomCount.length ? roomCount.includes(String($(this).data('rooms'))) : true;
                }
                let jsonString = $(this).data('apartment-layout-features');
                let apartmentLayoutsFeatures = '';
                let arrayApartmentLayoutFeatures = [];

                if(buildingFeature.length) {

                    $(jsonString).each(function () {
                        let singleLayoutArray = this;
                        if (buildingFeature.length === 1) {
                            apartmentLayoutsFeatures = buildingFeature.every(feature => (singleLayoutArray.toString().split(',').includes(feature)));
                            arrayApartmentLayoutFeatures.push(apartmentLayoutsFeatures);
                        } else if (buildingFeature.length > 1) {
                            apartmentLayoutsFeatures = buildingFeature.every(feature => (singleLayoutArray.toString().split(',').includes(feature)));
                            arrayApartmentLayoutFeatures.push(apartmentLayoutsFeatures);
                        }
                    });

                    if(buildingFeature.length === 1) {
                        if ($.inArray(true, arrayApartmentLayoutFeatures) != -1) {
                            apartmentLayoutsFeatures = true;
                        }
                    }else if(buildingFeature.length >1) {
                        if ($.inArray(true, arrayApartmentLayoutFeatures) != -1) {
                            apartmentLayoutsFeatures = true;
                        }
                    }
                }

                return (minArea ? (Number($(this).data('area-min')) >= Number(minArea) || Number($(this).data('area-max')) >= Number(minArea)) : true) &&
                    (maxArea ? (Number($(this).data('area-max')) <= Number(maxArea) || Number($(this).data('area-min')) <= Number(maxArea)) : true) &&
                    ((minPrice && Number($(this).data('price')) != 0 ) ? Number($(this).data('price')) >= Number(minPrice) : true) &&
                    ((maxPrice && Number($(this).data('price')) != 0) ? Number($(this).data('price')) <= Number(maxPrice) : true) &&
                    (roomCount.length ? roomShow : true) &&
                    ((buildingName.length !== 0) ? buildingName.includes($(this).data('building-name-desktop')) : true) &&
                    (apartmentStatus.length ? apartmentStatus.includes($(this).data('status')) : true) &&
                    (buildingStatus.length ? buildingStatus.includes($(this).data('building-status')) : true) &&
                    ((apartmentFeature.length !== 0) ? apartmentFeature.every(feature => String($(this).data('apartment-features')).split(',').includes(feature)) : true) &&
                    (apartmentFloor.length ? apartmentFloor.includes($(this).data('floor')) : true) &&
                    (onlyVacantHomes ? !["sold", "booked"].includes($(this).data('status')) : true) &&
                    ((buildingFeature.length !==0) ? apartmentLayoutsFeatures : true)
            });
            if ($('.page-template-template-homes .apartments-search').length == 0) {

                $('.table-empty-err').removeClass('active')
                if (filteredMobileApartments.length === 0) {
                    $('.table-empty-err').addClass('active')
                }
            }


            apartmentsList.hide();
            apartmentsWithImageList.hide();
            mobileApartmentsList.hide();

            apartmentsList.find('td').css('background-color', 'transparent');

            filteredApartments.each(function(index, el) {
                $(this).addClass('filtered-tr');
                if ((index + 1) % 2 == 0) {
                    $(el).find('td').css('background-color', '#FBFCFF');
                }
            })
            filteredMobileApartments.each(function(index, el) {
                $(this).addClass('filtered-tr');
            })

            filteredApartments.show();
            filteredApartmentsWithImage.show();
            // filteredMobileApartments.show();
            filteredMobileApartments.css('display', 'flex');

            const lastRow = apartmentsList.filter(':not(:hidden)').last();

            if (lastRow.length) {
                if (lastRow[0].getBoundingClientRect().top < window.innerHeight) {
                    $('.apartments-tab[data-tab="table"]').addClass('scroll-trigger-hidden');
                } else {
                    $('.apartments-tab[data-tab="table"]').removeClass('scroll-trigger-hidden');
                }
            } else {
                $('.apartments-tab[data-tab="table"]').addClass('scroll-trigger-hidden');
            }
            if ($('.page-template-template-homes .apartments-search').length == 0) {

                $('.table-empty-err').removeClass('active')
                if (filteredApartments.length === 0) {
                    $('.table-empty-err').addClass('active')
                }
            }
            if ($('.page-template-template-homes .apartments-search').length) {
                $('.table-empty-err').removeClass('active');
                $('.project-block').show();
                $('.project-block').each(function () {
                    let countTr = 0;
                    let countTrMobile = 0;
                    let btnShow =  $(this).find('.button-show-more');
                    btnShow.show();
                    $(this).show();
                    $(this).find('.apartments-table tbody tr.filtered-tr').each(function () {
                        countTr++;
                    })
                    if(countTr == 0 ) {
                        //$(this).hide();
                        $(this).find('.table-empty-err').addClass('active');
                        $(this).closest('.project-block').hide();
                    }
                    if(countTr <= 5) {
                        btnShow.hide();
                        $(this).find('.apartments-table tbody tr.filtered-tr').each(function (index) {
                            $(this).addClass('visible')

                        })
                        $(this).find('.apartments-table-mobile .apartment.filtered-tr').each(function () {
                            $(this).addClass('visible')
                        })
                    }

                    if(countTr > 5) {
                        btnShow.show();
                        $(this).find('.apartments-table tbody tr.filtered-tr').each(function (index) {
                            $(this).removeClass('visible')
                            if(index <= 4 ) {
                                if($(this).css('display') == 'none') {
                                    $(this).addClass('visible')
                                }
                            }
                        })
                    }
                });

                // Show general error message if no project is to show
                var projectsVisibleLength = $('.project-block:visible').length;
                if ( projectsVisibleLength == 0 ) {
                    $('.js-no-project').show();
                } else {
                    $('.js-no-project').hide();
                }

            }
        }

        $(window).on('scroll', function() {
            const lastRow = apartmentsList.filter(':not(:hidden)').last();

            if (lastRow.length) {
                if (lastRow[0].getBoundingClientRect().top < window.innerHeight) {
                    $('.apartments-tab[data-tab="table"]').addClass('scroll-trigger-hidden');
                } else {
                    $('.apartments-tab[data-tab="table"]').removeClass('scroll-trigger-hidden');
                }
            }
        });

        $('input[name="only-vacant-homes-mobile"]').on('change', function() {
            $('input[name="only-vacant-homes-desktop"]')[0].checked =  $('input[name="only-vacant-homes-mobile"]')[0].checked;
        })

        $('input[name="only-vacant-homes-desktop"]').on('change', function() {
            $('input[name="only-vacant-homes-mobile"]')[0].checked =  $('input[name="only-vacant-homes-desktop"]')[0].checked;
        })


        let ap_array= [];
        let queryStringApart = window.location.search;
        const urlParamsApart = new URLSearchParams(queryStringApart);
        if(urlParams.get('apartment-layout-feature')) {
            let apartment_feature_arr = urlParams.get('apartment-layout-feature').split(',');
            ap_array = apartment_feature_arr;
        }
        $('.apartment-features-block input').on('change', function(){

            var value = $(this).val();
            if ($(this).is(":checked")) {
                ap_array.push(value)
                updateUrlParams('apartment-layout-feature', ap_array.toString());
            } else {
                ap_array = ap_array.filter(item => item !== value);
                updateUrlParams('apartment-layout-feature',ap_array.toString());
            }

        })

        $('form[name="apartment-filters"] input:not([name="room-count"]), input[name="only-vacant-homes-desktop"], input[name="only-vacant-homes-mobile"]').on('change', filterApartments)

        $('form[name="apartment-filters"] input[name="room-count"]').on('change', function() {
            let array = [];
                $.each($('.room-selection input'), function(index,el) {
                if($(this).is(':checked')) {
                    array.push($(this))
                }
            })
            $('#price-range-slider').data("ionRangeSlider").update({
                from: $('#price-range-slider').data("min"),
                to: $('#price-range-slider').data("max"),
                min: $('#price-range-slider').data("min"),
                max:$('#price-range-slider').data("max"),
            });

            filterApartments();
            if(array.length != 0) {
                if (isFinite((minPriceRange)) && isFinite((maxPriceRange))) {
                    updatePriceRangeSlider($('#price-range-slider').data("ionRangeSlider"), minPriceRange, maxPriceRange);
                }
            }else {
                updatePriceRangeSlider($('#price-range-slider').data("ionRangeSlider"), $('#price-range-slider').data("min"), $('#price-range-slider').data("max"));
            }
        });

        $.each($('.checkbox-multiple'), function(index,el) {
                var array= [];
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                let input = $(this).children('li').find('input');

                if(index == 0) {
                    if(urlParams.get($(this).data('title'))) {
                        let building_name_desktop_arr = urlParams.get($(this).data('title')).split(',');
                        array = building_name_desktop_arr;
                    }
                }
                if(index == 1) {
                    if(urlParams.get($(this).data('title'))) {
                        let room_arr = urlParams.get($(this).data('title')).split(',');
                        array = room_arr;
                    }
                }
                if(index == 2) {
                    if(urlParams.get($(this).data('title'))) {
                        let building_status_arr = urlParams.get($(this).data('title')).split(',');
                        array = building_status_arr;
                    }
                }
                if(index == 3) {
                    if(urlParams.get($(this).data('title'))) {
                        let building_feature_arr = urlParams.get($(this).data('title')).split(',');
                        array = building_feature_arr;
                    }
                }
                if(index == 4) {
                    if(urlParams.get($(this).data('title'))) {
                        let apartment_floor_arr = urlParams.get($(this).data('title')).split(',');
                        array = apartment_floor_arr;
                    }
                }


            input.on('change', function (i) {

                var name = $(this).attr('name');
                var value = $(this).val();
                if ($(this).is(":checked")) {
                    array.push(value)
                    updateUrlParams(name, array.toString());
                } else {
                    array = array.filter(item => item !== value);
                    updateUrlParams(name,array.toString());
                }
            })
        })

        $('.clear-filters-trigger').on('click', function() {
            $('form[name="apartment-filters"]')[0].reset();

            $(rangeSliders).each(function(index, el) {
                el.reset();
            });

            $('input[name="only-vacant-homes-desktop"], input[name="only-vacant-homes-mobile"]').each(function(index, el) {
                $(el)[0].checked = false;
            });

            filterApartments();
            mobileApartmentsList.removeClass('building-hidden');

            $('.buildings-selection input[name="building-name-desktop"]').each(function(index, el) {
                $(el)[0].checked = false
            });

            $('.filters-block').toggleClass('active');
            $('.home-navigation-mobile, .c-mobile-navigation').toggleClass('z-index');
            $('.homes-page-nav-mobile').toggleClass('z-index');
            $('header').toggleClass('nav-up');
            $('body').toggleClass('overflow-hidden');
        });

        /**
         * Clear
         */
        $('.js-clear-filters').on('click', function() {

            $(rangeSliders).each(function(index, el) {
                var miinu = el.options.min;
                var maaxu = el.options.max;
                el.update({
                    min: miinu,
                    max: maaxu,
                    from: miinu,
                    to: maaxu
                });
                //el.reset();
            });

            $('input[name="building-name-desktop"]').removeAttr('checked');
            $('input[name="building-status"]').removeAttr('checked');
            $('input[name="apartment-layout-feature"]').removeAttr('checked');
            $('input[name="apartment-feature"]').removeAttr('checked');
            $('input[name="apartment-floor"]').removeAttr('checked');
            $('input[name="only-vacant-homes-desktop"], input[name="only-vacant-homes-mobile"]').removeAttr('checked');

            $('form[name="apartment-filters"]')[0].reset();


            filterApartments();
            mobileApartmentsList.removeClass('building-hidden');

            // Reset URL params - do this immediately for clear action
            const url = new URL(window.location);
            url.search = '';
            try {
                window.history.replaceState({}, '', url);
            } catch (e) {
                console.warn('URL update throttled due to browser limitations');
            }

            // Reset urlParams variabel
            urlParams = url.searchParams;

            $('.c-clear-filters-block').addClass('is-hidden');
        });

        $('.filters-trigger').on('click', function () {
            $('.filters-block').toggleClass('active');
            $('.home-navigation-mobile, .c-mobile-navigation').toggleClass('z-index');
            $('.homes-page-nav-mobile').toggleClass('z-index');
            $('header').toggleClass('nav-up');
            $('body').toggleClass('overflow-hidden');
        });

        $('.buildings-selection input[name="building-name-desktop"]').on('change', function() {
            const filters = $('.buildings-selection').serializeArray();
            const buildingIds = [];

            $(filters).each(function(index, el) {
                buildingIds.push(Number(el.value));
            })
            mobileApartmentsList.removeClass('building-hidden');
            if (buildingIds.length) {
                const filteredApartments = mobileApartmentsList.filter(function () {
                    return !buildingIds.includes($(this).data('building-name-desktop'));
                });

                filteredApartments.addClass('building-hidden');
            }
        })
    }
    // Debounce function to prevent too many history.replaceState calls
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    // Function to actually update the URL
    function doUpdateUrl() {
        url1.search = urlParams.toString();
        try {
            history.replaceState({}, null, url1.toString());
        } catch (e) {
            // Handle SecurityError in Safari when rate limit is exceeded
            console.warn('URL update throttled due to browser limitations');
        }
    }

    // Debounced version of URL update (300ms delay)
    const debouncedUrlUpdate = debounce(doUpdateUrl, 300);

    // Function to update multiple URL parameters at once without triggering multiple updates
    function updateUrlParamsBatch(params) {
        params.forEach(({param, value}) => {
            if (value) {
                urlParams.set(param, value);
            } else {
                urlParams.delete(param);
            }
        });

        debouncedUrlUpdate();
        $('.c-clear-filters-block').removeClass('is-hidden');
    }

    function updateUrlParams(param, value) {
        if (value) {
            urlParams.set(param, value);
        }
        else {
            urlParams.delete(param);
        }

        let filterLength = Array.from(urlParams).length;

        // Use debounced update instead of immediate update
        debouncedUrlUpdate();

        $('.c-clear-filters-block').removeClass('is-hidden');
    }

})(jQuery);


